export default __webpack_public_path__ + "static/media/fotoUsuario@2x.123580d5.png";